import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Cookies from "js-cookie";
import Logo from "../Logo";

const RegisterPage = ({ authStatus, setAuthStatus, setCurrentPage, setTitleDescription }) => {
  useEffect(() => {
    setTitleDescription("Fractofolio - Register - Create New Account", "The future of investment networking! Discover market insights, and make informed investment decisions with our community.")
  }, []);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [checked, setChecked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function isValidEmail(email) {
    // Regular expression for email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }
  
  const SignUpRequest = async () => {
    if (!isValidEmail(email)) {
      setError("Email is not valid.")
      return "";
    }

    if(password.length < 8) {
      setError("Password should be at least 8 characters in length.");
      return "";
    }
    setError("");

    setLoading(true);

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const data = {
        "email": email,
        "password": password,
        "ref": ""
      }
      const response = await axios.post(`${apiURL}/user/register`, data);
      if(response.data.status == 'ok') {
        Cookies.set("email", email, { expires: 1, path: '/'})
        Cookies.set('token', response.data.token, { expires: 1, path: '/'});
        setAuthStatus(true);
        setCurrentPage('auth/confirm-email');
      } else if(response.data.status == 'error') {
        setError(response.data.text);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <button onClick={() => setCurrentPage('feed')} className="">
            <Logo textAlign="text-center" />
          </button>
          <h2 className="text-gray-700 text-2xl font-bold mt-5">Sign up your account</h2>
          <p className="text-gray-500 text-sm">Create an account to access the features and benefits we offer</p>
        </div>
        
        <div className="linkedin-card">
          <div className="linkedin-card-content">
            <form className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input 
                  type="email" 
                  required 
                  className="linkedin-input"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value) }
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                <input 
                  type="password" 
                  required 
                  className="linkedin-input"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value) }
                />
              </div>

              <div className="text-xs text-gray-600">
                By clicking Agree & Join, you agree to the Fractofolio{' '}
                <span onClick={() => setCurrentPage('docs/terms')} className="text-linkedin-blue hover:underline cursor-pointer" >Terms of Service</span>,{' '}
                <span onClick={() => setCurrentPage('docs/privacy-policy')} className="text-linkedin-blue hover:underline cursor-pointer">Privacy Policy</span>, and{' '}
                <span onClick={() => setCurrentPage('docs/cookie-policy')} className="text-linkedin-blue hover:underline cursor-pointer">Cookie Policy</span>.
              </div>
              <button 
                type="button"
                onClick={() => { SignUpRequest() }}
                className="linkedin-btn-primary w-full py-3"
                disabled={loading}
              >
                {loading === false && (
                  <span>Agree & Join</span>
                )}
                {loading === true && (
                  <span>Loading...</span>
                )}
              </button>

              {error != "" && (
                <div className="mt-5 max-w-md sm:max-w-lg w-full bg-red-100 rounded-md p-3">
                  <p className="text-sm font-main-medium text-black">{error}</p>
                </div>
              )}

            </form>
            
            <div className="mt-6 text-center border-t border-gray-200 pt-6">
              <p className="text-sm text-gray-600">
                Already on Fractofolio?{' '}
                <button 
                  onClick={() => setCurrentPage('auth/login')}
                  className="text-linkedin-blue hover:underline font-medium"
                >
                  Sign in
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;